import React, { useState } from "react";
import axios from "axios";
import { StickyNote } from "lucide-react";
import Navbar from "../components/Navbar";

const PatientSummaryEntry = () => {
  const [patientId, setPatientId] = useState("");
  const [summary, setSummary] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchSummary = async () => {
    if (!patientId.trim()) {
      setError("Please enter a valid Patient ID.");
      return;
    }

    setError("");
    setLoading(true);
    try {
      const response = await axios.post(
        "https://lovencare.gopillz.com/api/summary",
        JSON.stringify({patient_id: patientId }),
        {
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
        console.log(response.data.status, response.data.summary)
      if (response.status === 200 && response.data.summary) {
        if (response.data.status===400){
            setError("Please enter a valid Patient ID.");

        }
        else{
            setSummary(response.data.summary|| "No summary available for this patient.");

        }
       
      } else {
        setSummary("");
        setError("No summary available for this patient.");
      }
    } catch (err) {
        if (err.status==400){
            setError("Please enter a valid Patient ID.");

        }
        else{
            setError("Failed to fetch summary. Please try again.");
            setSummary("");
        }
      
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-white h-screen">
      <Navbar />

      <div className="w-full flex justify-center pt-28 px-4">
        <div className="w-full max-w-2xl bg-white shadow-xl border border-blue-100 rounded-3xl p-8">
          <div className="flex flex-col items-center gap-3 mb-6">
            <div className="bg-blue-100 p-4 rounded-full shadow">
              <StickyNote className="w-8 h-8 text-blue-700" />
            </div>
            <h2 className="text-3xl font-bold text-blue-800">Patient Summary</h2>
            <p className="text-gray-600 text-sm font-medium">
              Enter the Patient ID below to retrieve their summary report.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <input
              type="text"
              placeholder="Enter Patient ID"
              className="w-full sm:w-2/3 px-4 py-3 border border-blue-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 text-gray-700"
              value={patientId}
              onChange={(e) => setPatientId(e.target.value)}
            />
            <button
              onClick={fetchSummary}
              disabled={loading}
              className="bg-gradient-to-r from-blue-500 to-sky-500 hover:from-blue-600 hover:to-sky-600 text-white px-6 py-3 rounded-xl shadow-md transition-transform transform hover:scale-105"
            >
              {loading ? "Loading..." : "View Summary"}
            </button>
          </div>

          {error && <p className="text-red-600 mt-4 font-medium">{error}</p>}

          {summary && (
            <div className="mt-8 bg-gradient-to-br from-white/80 to-blue-50/80 border border-blue-300 rounded-xl p-6 shadow-inner text-gray-800 text-base sm:text-lg font-medium leading-relaxed whitespace-pre-line">
              {summary}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PatientSummaryEntry;
